import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'AdminUI';
  arrowExpand = false;
  currentsubMenu = 0;
  constructor(private router: Router,) { }

  ngOnInit(): void {
  }
  toggleArrow (){
    this.arrowExpand =!this.arrowExpand;
  }
  NavClick(path:string,subMenu=0) {
    this.currentsubMenu = subMenu;
    this.router.navigate([path]);
  }
}
